var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.doShow),expression:"doShow"}],ref:"overlay-background",staticClass:"mhi-overlay"})])
}
var staticRenderFns = []

export { render, staticRenderFns }